import React, { useContext } from 'react';

import { Box } from '@mui/material';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { useClearRefinements } from 'react-instantsearch-hooks-web';

import CloseIcon from '../../../../assets/icons/CloseIcon';
import IKImage from '../../../../components/IKImage/IKImage';
import { CustomButton } from '../../../../components/UI/CustomButton';
import { TenantCtx, UserInfoCtx } from '../../../../containers/CommonLayout/CommonLayout';
import { DiscoverContext } from '../../../../context/DiscoverContext';
import { colorsPalette, useIsWidthUp } from '../../../../theme';
import useStyles from './style';

interface FiltersOverlayProps {
  attributesExcludedFromClear?: string[];
}

export const FiltersOverlay: React.FC<FiltersOverlayProps> = ({
  attributesExcludedFromClear,
  children,
}) => {
  const { openFiltersPanel, setOpenFiltersPanel } = useContext(DiscoverContext);
  const { tenant } = useContext(TenantCtx);
  const { userInfo } = useContext(UserInfoCtx);
  const { t } = useTranslation();
  const classes = useStyles();
  const isMobile = !useIsWidthUp('xl');

  const logoUrl = userInfo?.company?.logo_url ? userInfo?.company?.logo_url : tenant?.logo_url;

  const { refine, canRefine } = useClearRefinements({
    excludedAttributes: attributesExcludedFromClear,
  });

  const handleCloseOverlay = () => {
    setOpenFiltersPanel(false);
  };

  return (
    <Box className={cx(classes.overlay, openFiltersPanel && classes.overlayOpen)}>
      <Box className={classes.contentWrapper}>
        {isMobile && tenant?.logo_url && (
          <Box className={classes.overlayLogoWrapper}>
            <IKImage path={logoUrl || ''} draggable={false} alt={'logo'} />
          </Box>
        )}
        {isMobile && (
          <Box className={classes.closeBtnWrapper}>
            <CloseIcon
              className={classes.closeIcon}
              color={colorsPalette.primary}
              onClick={handleCloseOverlay}
            />
          </Box>
        )}
        {children}
        <Box className={classes.buttonsWrapper}>
          <CustomButton color="secondary" variant="outlined" onClick={refine} disabled={!canRefine}>
            {t('button.clearAll')}
          </CustomButton>
          {isMobile && (
            <CustomButton btnClass={classes.applyBtn} onClick={handleCloseOverlay}>
              {t('button.apply')}
            </CustomButton>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default FiltersOverlay;
